/**
 * Prose the agent wrote, rendered with the breaks it wrote in.
 *
 * Facet analyses are joined with a blank line between them, and the dashboard
 * used to pour the whole thing into one `<p>` — so a summary assembled from
 * three readings arrived as one unbroken block. This splits on the blank line
 * and nothing else: a single newline inside a paragraph is a wrap, not a break,
 * so it becomes a space rather than a new block.
 *
 * One paragraph in renders exactly the one `<p>` the call site rendered before,
 * so every adjacent-sibling margin rule around it still lands.
 */
export function Prose({ text, className }: { text: string; className?: string }) {
  const paragraphs = text
    .split(/\n\s*\n/)
    .map((part) => part.replace(/\s*\n\s*/g, ' ').trim())
    .filter((part) => part.length > 0);

  if (paragraphs.length === 0) return null;

  return (
    <>
      {paragraphs.map((paragraph, index) => (
        <p className={className} key={`${index}-${paragraph.slice(0, 24)}`}>
          {paragraph}
        </p>
      ))}
    </>
  );
}
